/**
 * A sheet header's facts, "·" separated. Every fact draws its dot in its own
 * left padding, and the row is pulled left under a clipping wrapper: whichever
 * fact starts a line has its dot clipped, so no line starts or ends on a dot.
 */
export function FactsLine({ facts }: { facts: readonly string[] }) {
  if (facts.length === 0) return null
  return (
    <div className="mt-0.5 overflow-hidden">
      <p className="text-neutral-low-contrast -ml-3 flex flex-wrap text-sm">
        {facts.map((fact) => (
          <span
            key={fact}
            className="before:text-neutral-hover-border relative pl-3 whitespace-nowrap before:absolute before:left-[3px] before:content-['·']">
            {fact}
          </span>
        ))}
      </p>
    </div>
  )
}
